export enum popupColorState {
  PRIMARY = 'border-[--algo-system-green-600]',
  SECONDARY = 'border-[--algo-system-blue-600]',
  WARNING = 'border-[--algo-system-yellow-500]',
  DANGER = 'border-[--algo-system-red-600]',
  GRAY = 'border-[--algo-accent-zinc-600]'
}
